const API_URL = process.env.REACT_APP_API_URL;

const ok = async (response, fallback) => {
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || fallback);
  }
  return response;
};

/**
 * Feedback threads, a two-way conversation between a user and the team.
 * `context` is the captured situation (route, env, user agent...) collected by the dialog.
 */
export const feedbackService = {
  // ---- user side ----
  async submitFeedback(payload, authenticatedFetch) {
    await ok(await authenticatedFetch(`${API_URL}/api/feedback`, {
      method: 'POST', body: JSON.stringify(payload),
    }), 'Failed to send feedback');
    return true;
  },

  async getMyThreads(authenticatedFetch) {
    const res = await ok(await authenticatedFetch(`${API_URL}/api/feedback`), 'Failed to load feedback');
    return res.json();
  },

  async replyToThread(id, body, authenticatedFetch) {
    await ok(await authenticatedFetch(`${API_URL}/api/feedback/${id}/messages`, {
      method: 'POST', body: JSON.stringify({ body }),
    }), 'Failed to send reply');
    return true;
  },

  // ---- admin side ----
  async adminListThreads(authenticatedFetch) {
    const res = await ok(await authenticatedFetch(`${API_URL}/api/admin/feedback`), 'Failed to load feedback');
    return res.json();
  },

  async adminReply(id, body, authenticatedFetch) {
    await ok(await authenticatedFetch(`${API_URL}/api/admin/feedback/${id}/messages`, {
      method: 'POST', body: JSON.stringify({ body }),
    }), 'Failed to send reply');
    return true;
  },

  async setResolved(id, resolved, authenticatedFetch) {
    await ok(await authenticatedFetch(
      `${API_URL}/api/admin/feedback/${id}/${resolved ? 'resolve' : 'reopen'}`,
      { method: 'POST' }), 'Failed to update status');
    return true;
  },
};

export default feedbackService;
